import type { ChunkzSite } from './chunkz';

export const reviewFilters = ['All', 'Unreviewed', 'Reviewed', 'Yes', 'Maybe', 'No', 'With notes'] as const;
export const marketFilters = ['All', 'On market', 'Off market', 'To confirm'] as const;
export type ReviewFilter = typeof reviewFilters[number];
export type MarketFilter = typeof marketFilters[number];
export type ShortlistSort = 'recommended' | 'comments';

export function matchesReview(site: ChunkzSite, filter: ReviewFilter): boolean {
  if (filter === 'All') return true;
  if (filter === 'Reviewed') return !!site.decision;
  if (filter === 'Unreviewed') return !site.decision;
  if (filter === 'With notes') return site.notes.length > 0;
  return site.decision === filter;
}

export function matchesMarket(site: ChunkzSite, filter: MarketFilter): boolean {
  if (filter === 'All') return true;
  if (filter === 'On market') return site.availability === 'marketed';
  if (filter === 'Off market') return site.availability === 'unavailable';
  return !site.availability || site.availability === 'check';
}

export function matchesSearch(site: ChunkzSite, query: string): boolean {
  return `${site.title} ${site.area} ${site.source || ''}`.toLowerCase().includes(query.trim().toLowerCase());
}

export function latestCommentTime(site: ChunkzSite): number {
  return Math.max(0, ...site.notes.map(note => Date.parse(note.createdAt) || 0));
}
